import {
  QUICK_IMPORT_SNIPPET_DETECTION,
  QUICK_IMPORT_VENDORED_DETECTION,
} from '../../../shared/featureFlags/flagNames';

import { isFeatureEnabled, useIsFeatureEnabled } from './featureFlags';

/**
 * Frontend helper to check whether the Quick Import scan-methods UI should be shown.
 * Returns true if either QUICK_IMPORT_VENDORED_DETECTION or QUICK_IMPORT_SNIPPET_DETECTION is enabled.
 */
export const shouldShowQuickImportScanMethods = (): boolean =>
  isFeatureEnabled(QUICK_IMPORT_VENDORED_DETECTION) ||
  isFeatureEnabled(QUICK_IMPORT_SNIPPET_DETECTION);

/**
 * Hook to check if the scan methods section should be visible.
 * Returns true if either QUICK_IMPORT_VENDORED_DETECTION or QUICK_IMPORT_SNIPPET_DETECTION is enabled.
 */
export const useShouldShowQuickImportScanMethods = (): boolean => {
  const hasVendored = useIsFeatureEnabled(QUICK_IMPORT_VENDORED_DETECTION);
  const hasSnippets = useIsFeatureEnabled(QUICK_IMPORT_SNIPPET_DETECTION);
  return hasVendored || hasSnippets;
};
